import { render, staticRenderFns } from "./ui-close-hint.vue?vue&type=template&id=5d2150af&scoped=true&"
import script from "./ui-close-hint.vue?vue&type=script&lang=js&"
export * from "./ui-close-hint.vue?vue&type=script&lang=js&"
import style0 from "./ui-close-hint.vue?vue&type=style&index=0&id=5d2150af&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2150af",
  null
  
)

export default component.exports